(function() {
  if($('.js-logo-slider').length > 0){
    var max = $('.js-logo-slider').length;
    var slideOut = 0;
    var slideIn = 1;

    function slider(){
      if (slideOut == max){
        slideOut = 0;
      }
      if (slideIn == max){
        slideIn = 0;
      }

      $('.js-logo-slide-' + slideOut).fadeOut(800, "swing", function(){
        $('.js-logo-slide-' + slideIn).fadeIn(800);

        slideOut++;
        slideIn++;
      });

      setTimeout(slider, 9000);
    }
    setTimeout(slider, 9000);
  }
}());
